import {
  CopyOutlined,
} from '@ant-design/icons'
import { Button, Tooltip, Dropdown, Avatar, Menu, Popover, QRCode, message } from 'antd'
import { useTheme } from '../../hooks/useTheme'
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { useStyle } from '../../style'
import { Space } from 'antd'
import React, { useEffect, useState } from 'react'

import { pageComponents } from '../../const'
import FunctionMenu from '../../pages/components/FunctionMenu'

import { useConversationContext } from '../../stores/conversation.store'


import OnlineSidebar from '../../pages/components/OnlineSidebar'
import { isOnlineOpenAtom } from '../../stores/online.store'
import { useAtom } from 'jotai'


import sidebar2 from '@/assets/icon/AI／icon／sidebar-2.png'
import { useFunctionMenuStore } from '@/stores/functionMenu.store'
import style from './style.module.less';
import phone from '@/assets/icon/AI／icon／phone.png'
import UserProfilePanel from './UserProfilePanel'
import { useUserActions } from '@/hooks/useUser'
const Independent: React.FC = () => {
  const { actualTheme, toggleTheme } = useTheme()
  const { styles } = useStyle()

  const isDark = actualTheme === 'dark'
  const [isOnlineOpen] = useAtom(isOnlineOpenAtom)
  const { fetchConversations } = useConversationContext()

  const { syncUserProfile } = useUserActions();
  const { userInfo } = useUserActions();

  useEffect(() => {
    fetchConversations()
    syncUserProfile();
  }, [])
  const { menuCollapsed, toggleMenuCollapsed, chooseActiveMenuPage } =
    useFunctionMenuStore()

  const inviteUrl = "https://senlaniot.com/ai";

  // 1. 弹出层的内容（根据图片样式定制）
  const mobileViewContent = (
    <div style={{ width: 500, textAlign: 'center', padding: '16px' }}>
      <div style={{ marginBottom: 24, fontWeight: 'bold', fontSize: 18 }}>手机查看</div>

      {/* 二维码部分 */}
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 8 }}>
        <QRCode value={inviteUrl} size={160} bordered={false} />
      </div>

      <div style={{ color: '#999', marginBottom: 24 }}>👆扫码使用</div>

      <div style={{ fontSize: 13, marginBottom: 12 }}>复制链接，并在手机浏览器中打开使用</div>

      {/* 链接复制区域 */}
      <div style={{ display: 'flex', gap: 8, alignItems: "center" }}>
        <div style={{
          backgroundColor: '#f5f5f5',
          padding: '4px 12px',
          borderRadius: 4,
          flex: 1,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          lineHeight: '32px',
          fontSize: 12
        }}>
          {inviteUrl}
        </div>
        <Button
          type="primary"
          icon={<CopyOutlined />}
          onClick={() => {
            navigator.clipboard.writeText(inviteUrl);
            message.success('复制成功')
          }}
        >
          复制链接
        </Button>
      </div>
    </div>
  );
  // 根据当前主题设置body背景色
  useEffect(() => {
    document.body.style.backgroundColor = isDark ? '#141414' : '#ffffff'
    if (isDark) {
      document.body.classList.add('dark-theme')
    } else {
      document.body.classList.remove('dark-theme')
    }
  }, [isDark])

  // ==================== Render =================
  return (
    <>


      <Space className={styles.topBtns}>
        <Button
          type="text"
          icon={
            <img src={sidebar2} alt="menuCollapsed" style={{ height: 18 }} />
          }
          onClick={toggleMenuCollapsed}
        />
      </Space>
      <Space
        className={
          isOnlineOpen ? styles.topLinkWrapper : styles.topLinkWrapperHide
        }
      >
        {/* <Tooltip title={isDark ? '切换到亮色模式' : '切换到暗色模式'}>
          <Button
            className="theme-toggle-btn"
            icon={isDark ? <BulbFilled /> : <BulbOutlined />}
            onClick={toggleTheme}
          />
        </Tooltip> */}
        {/* <Tooltip title={'问题反馈'}>
          <a
            href="https://senlaniot.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button icon={<FormOutlined />} />
          </a>
        </Tooltip> */}
        {/* <Tooltip title={'上传知识库'}>
          <Button
            icon={<CloudUploadOutlined onClick={() => navigate(`/upload`)} />}
          />
        </Tooltip> */}
        <div className={style.mobileOnlyTrigger}>
          <Popover
            content={mobileViewContent}
            trigger="hover"
            placement="bottomRight"
            arrow={false}
          >
            <div className={style.iconButton}>
              <img src={phone} alt="phone" style={{ width: 24 }} />
              <span style={{ marginLeft: 4 }}>手机端</span>
            </div>
          </Popover>
        </div>
        {userInfo.name && !userInfo.name.includes('temporary') ? <Popover
          content={
            <UserProfilePanel
            />
          }
          trigger="hover"
          placement="bottomRight"
          arrow={false} // 隐藏小箭头使UI更现代
          overlayClassName={style.userProfilePopover}
        >
          <div className={styles.userDropdown} style={{ cursor: 'pointer' }}>
            <Avatar src={userInfo.avatar} style={{ backgroundColor: '#2f54eb' }} key={userInfo.avatar || 'loading'}>
              {userInfo.name?.[0]}
            </Avatar>
          </div>
        </Popover> : <Button onClick={() => window.dispatchEvent(new CustomEvent('show-login-modal'))} >登录</Button >}


      </Space>

      <div className={styles.layout}>
        <FunctionMenu />
        {/* 菜单页面容器 */}
        <div className={styles.menuPagesWrapper}>
          <Routes>
            <Route path="/" element={<Navigate to="/chat" replace />} />
            {Object.entries(pageComponents).map(([key, Component]) => (
              <React.Fragment key={key}>
                {/* 类页面路由 */}
                <Route
                  path={`/${key}`}
                  element={
                    <div className={styles.pageWrapper}>
                      <Component />
                    </div>
                  }
                />
                {/* 实例页面路由 */}
                <Route
                  path={`/${key}/:conversationId`}
                  element={
                    <div className={styles.pageWrapper}>
                      <Component />
                    </div>
                  }
                />
              </React.Fragment>
            ))}
          </Routes>

          <div className={styles.footer}>
            {/* Copyright © 2025 senlan-hope All rights reserved. */}
            内容由Hi.ai生成，可能会犯错，仅供参考
          </div>
        </div>
        {isOnlineOpen && <OnlineSidebar />}
      </div>
    </>
  )
}
export default Independent
